export { default } from './PaymentsType'
export * from './PaymentsType.styles'
export type { PaymentsTypeRef } from './PaymentsType'
